export default __webpack_public_path__ + "locales/zh-CN/DataReassignmentDialog.json?hash=d99aa4845e070ac28c0aeaa116995566";